export const configSources = {
    1: 'Бюджетное место',
    2: 'Целевая квота',
    3: 'Особая квота',
    4: 'С оплатой обучения',
    5: 'За счёт иных средств',
    6: 'Отдельная квота',
    7: 'Совмещенная квота (целевая, особая и отдельная квоты)',
    8: 'Совмещенная квота (целевая и особая квоты)',
    9: 'Совмещенная квота (целевая и отдельная квоты)',
    10: 'Совмещенная квота (особая и отдельная квоты)',
    11: 'Детализированная целевая квота',
};

export const configSourcesTranslateMap = {
    1: 'state_funded_place',
    2: 'target_admission_quota',
    3: 'special_admission_quota',
    4: 'fee_paying_place',
    5: 'alternative_funding_track',
    6: 'separate_quota',
    7: 'combined_quota_target_spec_sep',
    8: 'combined_quota_target_spec',
    9: 'combined_quota_target_sep',
    10: 'combined_quota_spec_sep',
    11: 'detailed_target_quota',
};
